import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AuthTwoFactorDisablePayload } from 'api/actions/auth-two-factor-disable/auth-two-factor-disable-payload';
import { AuthTwoFactorDisablePathParameters } from 'api/actions/auth-two-factor-disable/auth-two-factor-disable-path-parameters';
import { AuthTwoFactorDisableResponse } from 'api/actions/auth-two-factor-disable/auth-two-factor-disable-response';

type AuthTwoFactorDisableQueryParameters = Record<string, any>;

/**
 * The path of the AuthTwoFactorDisable action.
 */
export const authTwoFactorDisableActionPath = new SweetPath<keyof AuthTwoFactorDisablePathParameters>(
  '/api/auth/two-factor/disable',
  { path: '{param}' }
);

/**
 * Creates a contextualized AuthTwoFactorDisable actions.
 */
export default function createAuthTwoFactorDisableAction(axios: AxiosInstance) {
  return function authTwoFactorDisableAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: AuthTwoFactorDisableQueryParameters;
    payload: AuthTwoFactorDisablePayload;
  }) {
    const path = authTwoFactorDisableActionPath.original;

    return axios.request<AuthTwoFactorDisableResponse, AuthTwoFactorDisableResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
